const impedances = [2, 4, 6, 8, 16];
const closeButtonSVG = `
<svg class="close-btn-svg" xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="24px">
  <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 
           56 56-224 224 224 224-56 56-224-224-224 224Z"/>
</svg>`;
const removeIcon = `<div></div>`;

// Utility Functions
const calculateSpeakerPosition = (container) =>
  container.querySelectorAll("select").length + 1;

function updateSpeakerLabels(type) {
  if (type === "srs-prl") {
    document.querySelectorAll(".srs-prl-group").forEach((group) => {
      group.querySelectorAll(".srs-prl-speaker").forEach((speaker, i) => {
        const label = speaker.querySelector(".speaker-label");
        label.textContent = `Speaker ${i + 1}`;
        label.htmlFor = speaker.querySelector("select").id;
      });
    });
    return;
  }

  document.querySelectorAll(`.${type}-speaker`).forEach((speaker, i) => {
    const label = speaker.querySelector("label");
    const select = speaker.querySelector("select");
    const id = `${type}-spk-${i + 1}`;
    label.textContent = `Speaker ${i + 1}`;
    label.htmlFor = id;
    select.id = id;
  });
}

function addSpeakerClickEvent(button, type) {
  const actions = {
    parallel: () => {
      createSpeaker("parallel");
      showAmplifiersBasedOnImpedance(calculateTotalParallelImpedance());
    },
    series: () => {
      createSpeaker("series");
      showAmplifiersBasedOnImpedance(8);
    },
    "srs-prl": () => {
      createSrsPrlSpeaker();
      showAmplifiersBasedOnImpedance(calculateTotalSrsPrlImpedance());
    },
  };
  button.addEventListener("click", actions[type]);
}

// Impedance Calculations
function calculateTotalParallelImpedance() {
  const values = Array.from(
    document.querySelectorAll(".parallel-speaker select"),
  ).map((select) => Number(select.value));
  const reciprocalSum = values.reduce((sum, imp) => sum + 1 / imp, 0);
  const total = 1 / reciprocalSum;
  document.getElementById("total-parallel-imp").innerText =
    `Total Impedance = ${total % 1 ? total.toFixed(2) : total}Ω`;

  showAmplifiersBasedOnImpedance(Math.floor(total));

  return Math.floor(total);
}

function calculateTotalSeriesImpedance() {
  const total = Array.from(document.querySelectorAll(".series-speaker select"))
    .map((select) => Number(select.value))
    .reduce((prev, curr) => prev + curr, 0);
  document.getElementById("total-series-imp").innerText = `Total Impedance = ${
    total % 1 ? total.toFixed(2) : total
  }Ω`;
}

function calculateTotalSrsPrlImpedance() {
  const groups = document.querySelectorAll(".srs-prl-group");
  let reciprocalSum = 0;

  groups.forEach((group) => {
    const sum = Array.from(group.querySelectorAll("select")).reduce(
      (prev, select) => prev + Number(select.value),
      0,
    );
    if (sum) reciprocalSum += 1 / sum;
  });

  const total = reciprocalSum ? 1 / reciprocalSum : 0;
  document.getElementById("total-srs-prl-imp").innerText = `Total Impedance = ${
    total % 1 ? total.toFixed(2) : total
  }Ω`;

  showAmplifiersBasedOnImpedance(total);
  return total;
}

// Speaker Creation
function createSpeaker(type) {
  const container = document.getElementById(`${type}-calculation-section`);
  const wrapper = document.createElement("div");
  wrapper.className = `${type}-speaker`;

  const label = document.createElement("label");
  const select = document.createElement("select");
  const flex = document.createElement("div");
  const removeBtn = document.createElement("button");

  flex.className = "select-flex";
  removeBtn.className = "remove-btn";
  removeBtn.innerHTML = removeIcon;

  const pos = calculateSpeakerPosition(container);
  select.id = `${type}-spk-${pos}`;
  label.className = "speaker-label";
  label.textContent = `Speaker ${pos}`;
  label.htmlFor = select.id;

  impedances.forEach((val) => {
    const opt = document.createElement("option");
    opt.value = val;
    opt.textContent = `${val}Ω`;
    select.appendChild(opt);
  });
  select.value = "8";

  const calcFns = {
    parallel: calculateTotalParallelImpedance,
    series: calculateTotalSeriesImpedance,
  };

  select.addEventListener("change", calcFns[type]);
  removeBtn.addEventListener("click", () => {
    wrapper.remove();
    updateSpeakerLabels(type);
    calcFns[type]();
    if (type === "parallel")
      showAmplifiersBasedOnImpedance(calculateTotalParallelImpedance());
    if (type === "series") showAmplifiersBasedOnImpedance(8);
  });

  wrapper.append(label, flex);
  flex.append(select, removeBtn);
  container.appendChild(wrapper);
}

// Series-Parallel Group Creation
function createSrsPrlSpeaker(container) {
  const wrapper = document.createElement("div");
  wrapper.className = "srs-prl-speaker";

  const label = document.createElement("label");
  const select = document.createElement("select");
  const flex = document.createElement("div");
  const removeBtn = document.createElement("button");

  flex.className = "select-flex";
  removeBtn.className = "remove-btn";
  removeBtn.innerHTML = removeIcon;

  const pos = calculateSpeakerPosition(
    document.getElementById("srs-prl-calculation-section"),
  );
  select.id = `srs-prl-spk-${pos}`;
  label.className = "speaker-label";
  label.textContent = `Speaker ${pos}`;
  label.htmlFor = select.id;

  impedances.forEach((val) => {
    const opt = document.createElement("option");
    opt.value = val;
    opt.textContent = `${val}Ω`;
    select.appendChild(opt);
  });
  select.value = "8";

  select.addEventListener("change", calculateTotalSrsPrlImpedance);
  removeBtn.addEventListener("click", () => {
    wrapper.remove();
    updateSpeakerLabels("srs-prl");
    calculateTotalSrsPrlImpedance();
  });

  wrapper.append(label, flex);
  flex.append(select, removeBtn);
  container.appendChild(wrapper);

  updateSpeakerLabels("srs-prl");
  calculateTotalSrsPrlImpedance();
}

function createSrsPrlGroup() {
  const section = document.getElementById("srs-prl-calculation-section");

  const group = document.createElement("div");
  group.className = "srs-prl-group";

  const header = document.createElement("div");
  header.className = "srs-prl-speaker-header-container";

  const title = document.createElement("h4");
  title.className = "srs-prl-group-header";
  title.textContent = `Series Group ${
    section.querySelectorAll(".srs-prl-group").length + 1
  }`;

  const removeGroupBtn = document.createElement("button");
  removeGroupBtn.className = "srs-prl-remove-group-btn";
  removeGroupBtn.innerHTML = closeButtonSVG;
  removeGroupBtn.addEventListener("click", () => {
    group.remove();
    updateSpeakerLabels("srs-prl");
    calculateTotalSrsPrlImpedance();
  });

  const addSpeakerBtn = document.createElement("button");
  addSpeakerBtn.className = "add-srs-prl-speaker-btn";
  addSpeakerBtn.textContent = "Add Speaker";

  const flex = document.createElement("div");
  flex.className = "srs-prl-speaker-flex";

  header.append(title, removeGroupBtn);
  group.append(header, document.createElement("hr"), addSpeakerBtn, flex);

  addSpeakerBtn.addEventListener("click", () => createSrsPrlSpeaker(flex));

  createSrsPrlSpeaker(flex);
  section.appendChild(group);

  updateSpeakerLabels("srs-prl");
  calculateTotalSrsPrlImpedance();
}

// Tab Switching
document.querySelectorAll(".tab-button").forEach((btn, i) => {
  btn.addEventListener("click", () => {
    document
      .querySelectorAll(".tab-content")
      .forEach((tab) => tab.classList.remove("active"));
    document
      .querySelectorAll(".tab-button")
      .forEach((b) => b.classList.remove("active"));
    document.querySelectorAll(".tab-content")[i].classList.add("active");
    btn.classList.add("active");
    if (btn.classList.contains("parallel-tab-btn")) {
      showAmplifiersBasedOnImpedance(calculateTotalParallelImpedance());
    } else if (btn.classList.contains("series-tab-btn")) {
      showAmplifiersBasedOnImpedance(8);
    } else {
      showAmplifiersBasedOnImpedance(calculateTotalSrsPrlImpedance());
    }
  });
});

// Button Events
addSpeakerClickEvent(
  document.getElementById("add-parallel-speaker-btn"),
  "parallel",
);
addSpeakerClickEvent(
  document.getElementById("add-series-speaker-btn"),
  "series",
);
document
  .getElementById("add-srs-prl-speaker-group")
  .addEventListener("click", createSrsPrlGroup);

// Initialise
document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".parallel-speaker select")
    .forEach((s) =>
      s.addEventListener("change", calculateTotalParallelImpedance),
    );
  document
    .querySelectorAll(".series-speaker select")
    .forEach((s) =>
      s.addEventListener("change", calculateTotalSeriesImpedance),
    );
  document
    .querySelectorAll(".srs-prl-speaker select")
    .forEach((s) =>
      s.addEventListener("change", calculateTotalSrsPrlImpedance),
    );

  document.querySelectorAll(".srs-prl-group").forEach((group) => {
    const btn = group.querySelector(".add-srs-prl-speaker-btn");
    const flex = group.querySelector(".srs-prl-speaker-flex");
    if (btn && flex)
      btn.addEventListener("click", () => createSrsPrlSpeaker(flex));
  });

  calculateTotalParallelImpedance();
  calculateTotalSeriesImpedance();
  calculateTotalSrsPrlImpedance();
});

function showAmplifiersBasedOnImpedance(impedance) {
  const amps = document.querySelectorAll(".impedance-calc-product");
  const noAmpsMessage = document.getElementById("no-amps-msg");

  amps.forEach((amp) => {
    const tags = amp.dataset.tags.split(",");
    let hideAmp = false;

    if (impedance > 8) {
      hideAmp = false;
      noAmpsMessage.style.display = "none";
    } else if (impedance >= 4 && impedance <= 8) {
      hideAmp = !tags.includes("4ohms") && !tags.includes("2ohms");
      noAmpsMessage.style.display = "none";
    } else if (impedance >= 2 && impedance <= 4) {
      hideAmp = !tags.includes("2ohms");
      noAmpsMessage.style.display = "none";
    } else {
      hideAmp = true;
      noAmpsMessage.style.display = "block";
    }

    amp.style.display = hideAmp ? "none" : "block";
  });
}
